var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16699 7.5H10.8337V5.83334H9.16699V7.5ZM10.0003 16.6667C6.32533 16.6667 3.33366 13.675 3.33366 10C3.33366 6.32501 6.32533 3.33334 10.0003 3.33334C13.6753 3.33334 16.667 6.32501 16.667 10C16.667 13.675 13.6753 16.6667 10.0003 16.6667ZM10.0003 1.66667C8.90598 1.66667 7.82234 1.88222 6.8113 2.30101C5.80025 2.7198 4.88159 3.33363 4.10777 4.10745C2.54497 5.67025 1.66699 7.78987 1.66699 10C1.66699 12.2101 2.54497 14.3298 4.10777 15.8926C4.88159 16.6664 5.80025 17.2802 6.8113 17.699C7.82234 18.1178 8.90598 18.3333 10.0003 18.3333C12.2105 18.3333 14.3301 17.4554 15.8929 15.8926C17.4557 14.3298 18.3337 12.2101 18.3337 10C18.3337 8.90566 18.1181 7.82202 17.6993 6.81098C17.2805 5.79993 16.6667 4.88127 15.8929 4.10745C15.1191 3.33363 14.2004 2.7198 13.1894 2.30101C12.1783 1.88222 11.0947 1.66667 10.0003 1.66667ZM9.16699 14.1667H10.8337V9.16667H9.16699V14.1667Z",
    fill: "#0B29FB"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.bb9e60c194605939fc72c7f8d10854ac.svg";